import styled from "styled-components";
import background from "../../../assets/images/background.png";

export const Container = styled.div`
  width: 100vw;
  height: ${(props) => (props.height ? props.height : "100vh")};
  background-image: ${(props) =>
    props.background ? `url(${props.background})` : `url(${background})`};
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  background-attachment: scroll;
  color: #fff;
  overflow-y: scroll;

  h1.section-name {
    font: bold italic 36px "Roboto Condensed";
    text-align: center;
    margin-top: 2em;
    margin-bottom: 0.75em;
    text-transform: uppercase;
  }
`;
export const Row = styled.div`
  display: flex;
  justify-content: ${(props) =>
    props.justify ? props.justify : "space-between"};
  align-items: center;
  flex-wrap: wrap;
  width: ${(props) => (props.width ? props.width : "100%")};
  height: ${(props) => (props.height ? props.height : "")};
  background-color: ${(props) => (props.background ? props.background : "")};
`;

export const FabButton = styled.button`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  align-self: flex-end;
  width: 90px !important;
  height: 90px !important;
  position: absolute;
  bottom: ${(props) => (props.bottom ? props.bottom : "60px")};
  right: ${(props) => (props.right ? props.right : "30px")};
  border-radius: 50%;
  border: none;
  background-color: ${(props) => props.bgColor};
  z-index: 1000;
  box-shadow: 2px 2px 5px #000;
  color: #fff;
  transition: transform 300ms ease;

  p.fab-text {
    margin-bottom: 0 !important;
    font-size: 12px;
  }

  :hover,
  :active,
  :focus {
    border-radius: 50%;
    color: #fff;
    transform: scale(1.1);
  }
`;
export const ContentWrapper = styled.div`
  width: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 600px;
  background-color: ${(props) =>
    props.background ? props.background : "transparent"};

  .start-assess {
    height: 40px;
    padding: 0.25em 1em;
    margin-top: 2em;
  }
  div.toggle-plan-wrapper {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
    width: 400px;
    justify-content: space-around;
    margin-top: 2em;

    p {
      color: #fff;
      font: bold normal 24px "Roboto";
    }
  }
`;
export const ContentHeading = styled.h1`
  font: bold italic 36px "Roboto Condensed" !important;
  text-align: center;
  text-transform: uppercase;
  color: ${(props) => (props.color ? props.color : "#fff")};
  margin-bottom: ${(props) => (props.color ? "1em" : "")};
`;
export const ContentBody = styled.p`
  text-align: ${(props) => (props.textAlign ? props.textAlign : "left")};
  font: bold italic 24px "Roboto Condensed" !important;

  span {
    color: #acff24;
    text-transform: capitalize;
  }
`;
export const FormContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-evenly;
  width: ${(props) => (props.width ? props.width : "65%")};
  height: 100%;
  min-width: 400px;
  background-color: #1a1a1a;
  border-radius: 2px;
  padding: 12px 16px;

  i.close-modal {
    color: #acff24;
    align-self: flex-end;
    font-size: 32px;
    cursor: pointer;
  }

  img.logo {
    width: 160px;
    height: auto;
  }
  .designation-title {
    font: italic bold 24px "Roboto Condensed";
    color: #fff;
    text-align: center;
    text-transform: uppercase;
  }

  form {
    padding: 0 1em 0 1em;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-evenly;
    width: 100%;
    min-width: 400px;

    h2.form-header {
      font: italic bold 24px "Roboto Condensed";
      margin-left: 2.5%;
      align-self: flex-start;
      color: #fff;
    }

    .fields-wrapper {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-evenly;
      width: 95%;
      background-color: #2d2d2d;
      border-radius: 2px;
      padding: 4px 28px 28px 28px;

      div.transaction-method {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        margin-top: 8px;

        p.transaction-card {
          font: italic bold 16px "Roboto Condensed";
          margin: 0 !important;
        }
      }
    }

    button.register-parent {
      height: 40px;
      padding: 0 2em;
      margin: 0 0 0 0;
    }

    .already-registered {
      font: normal italic 14px "Roboto Condensed";
      color: #fff;
      margin: 0.5em 0;
      font-weight: bold;

      span {
        color: var(--blue);
      }
      span:hover {
        color: #ff0033;
        cursor: pointer;
      }
    }
  }
`;

export const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: ${(props) => (props.width ? props.width : "100%")};
  margin-top: 24px;
  color: #fff;
  p {
    font: italic bold 16px "Roboto Condensed";
    margin-bottom: 0;
    text-transform: uppercase;

    a {
      color: #3ee9f7;
      text-decoration: underline;
      text-transform: initial;
      display: inline;
      font-size: 14px;
      font-weight: normal;
      margin-left: 4px;

      :hover {
        color: #acff24;
      }
    }
  }
  .date-picker {
    width: 100%;
  }
  .custom-textfield,
  .custom-datepicker {
    margin-top: 8px !important;
  }

  div {
    width: 100%; // stripe stuff
  }
`;

export const CtaWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
  margin: 8px 0;

  button {
    padding: 0 2em;
    height: 36px;
  }
`;

export const Disclaimer = styled.p`
  font: normal normal 14px "Roboto Condensed" !important;
  text-align: center;
  width: 90%;

  a {
    color: #acff24;
    text-decoration: none;

    :hover {
      text-decoration: underline;
    }
  }
`;

export const Footer = styled.footer`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  // height: 200px;
  width: 100%;
  background-color: #1a1a1a;
  position: fixed;
  bottom: 0;

  button {
    margin: 1em 5em 1em 1em;
    padding: 0 4em;
    height: 45px;
  }
`;

export const VideoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  // flex-wrap: wrap;
  align-items: center;
  width: ${(props) => props.width};
  min-width: 400px;
  margin: 2em;
  border: solid #acff24 1px;

  .prepayment-video {
    width: 100%;
  }

  h3 {
    font: normal bold 20px "Roboto Condensed";
    margin-top: 1.25em;
    text-align: center;
  }
`;
export const InputItemsRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  // margin-top: 6px;

  & > * {
    width: 45% !important;
  }
`;
export const ModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-width: 400px;
  height: ${(props) => (props.height ? props.height : "400px")};
  z-index: 10002;
  background-color: #2a2a2a;
  padding: 20px 8px;
`;

export const FeedbackP = styled.p`
  font: bold italic 18px "Roboto Condensed";
  text-align: center;
  text-transform: uppercase;
  color: #fff;
  line-height: 2;

  span {
    color: ${(props) => (props.success ? "#acff24" : "#ff0033")};
  }
`;

// packages
export const PackagesWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  // width: 70%;
  // max-width: 900px;
  align-items: flex-start;
  justify-content: space-around;
  margin-top: 2em;
  margin-bottom: 10em;

  > * {
    margin: 0 32px 28px 0;
  }

  .recommended-package {
    transform: scale(1.125);
    background-color: #000;
  }
`;

export const PackageItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  font-family: Roboto;
  width: 360px;
  height: 825px;
  border: 1px solid #acff24;
  margin: 0.5em 2em;
  padding: 20px;

  div.package-name {
    width: 100%;
    padding: 0.5em 1em;

    h1.package-title {
      font-size: 32px;
      text-transform: uppercase;
      text-align: center;
      font-weight: bold;
    }
    p.package-target {
      font: italic bold 16px "Roboto Condensed";
      text-align: center;
      text-transform: uppercase;
    }
  }

  div.package-value {
    padding: 0.5em 1em;
    h1.price {
      font-size: 38px;
      color: #acff24;
      text-transform: uppercase;
      margin-bottom: 24px;

      span,
      sub {
        color: #fff;
        font-size: 15px;
      }
    }

    p.package-benefit {
      color: #fff;
      font: normal italic 15px "Roboto Condensed";

      i {
        color: #acff24;
        margin-right: 6px;
      }
    }
  }

  div.features-list {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-end;
    font-size: 16px;
    // border-top: 1px #555 solid;
    width: 100%;
    height: 70%;
    padding: 2em 2em 1em 2em;
    // margin-top: 2.25em;

    p {
      text-align: center;
    }

    button.package-button {
      padding: 0 2.5em;
      height: 45px;
      margin: 1.5em 0;
      border-radius: 2px;

      &.selected {
        background-color: #75db00;
        border: 2px solid #fff;
      }

      p.p-selected-package {
        margin-bottom: 0 !important;
        font: italic bold 16px "Roboto Condensed";
      }
    }
  }
`;

export const TooltipParagraph = styled.p`
  position: relative;

  span.hover-tooltip {
    font-size: 13px;
    width: 200px;
    position: absolute;
    background-color: #acff24;
    padding: 6px 16px;
    border-radius: 3px;
    left: 150%;
    top: -30px;
    z-index: 300;
    opacity: 0;
    transition: all 0.3s ease-in-out;
    color: #000;
  }

  &:hover {
    span.hover-tooltip {
      left: 80%;
      opacity: 1;
      transition: all 0.3s ease-in-out;
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/Onboard/Common/Common.styles.ts